import { createSlide } from "../slidesOps/createSlide";
export function ArchaeologyAndTheBibleMarch31(val) {
    const html = `
        <style>
            #ArchaeologyAndTheBibleMarch31 h1,
            #ArchaeologyAndTheBibleMarch31 h2 {
                text-align: center;
                font-family: 'IBM Plex Serif', serif;
                margin: 0;
                padding: 0;
                font-style: italic;
            }

            #ArchaeologyAndTheBibleMarch31 h1 {
                font-weight: 900;
            }

            #ArchaeologyAndTheBibleMarch31 h2 {
                font-weight: 300;
            }

            #ArchaeologyAndTheBibleMarch31 h3 {
                font-weight: 300;
                font-family: 'IBM Plex Serif', serif;
                margin: 0;
                text-shadow: 0 3px 3px #000, 0 -3px 3px #000;
            }

            #ArchaeologyAndTheBibleMarch31 .image-slides {
                height: 400px;
                margin: 8vh 0;
            }

            #ArchaeologyAndTheBibleMarch31 .image-slides img {
                height: 400px;
            }

            .fragment.scale-in {
                opacity: 0;
                transform: scale(.5);
                transition-duration: 0s !important;
            }

            .fragment.scale-in.visible {
                opacity: 1;
                transform: scale(1);
                transition-duration: 1s !important;
            }

            .fragment.carousel img {
                opacity: 0;
                transform: scale(0);
                left: 25vw;
                position: relative;
            }

            .present .fragment.carousel.visible img {
                animation-name: carousel;
                animation-duration: 10s;
                animation-iteration-count: 1;
            }

            .fragment.carousel.visible img:nth-child(1) {
                animation-delay: 0s;
            }

            .fragment.carousel.visible img:nth-child(2) {
                animation-delay: 9.5s;
            }

            .fragment.carousel.visible img:nth-child(3) {
                animation-delay: 19s;
            }

            @keyframes carousel {
                0% {
                    opacity: 0;
                    transform: scale(0);
                    left: 25vw;
                }
                15% {
                    opacity: 1;
                    transform: scale(1);
                    left: 0;
                }
                95% {
                    opacity: 1;
                    transform: scale(1);
                    left: 0;
                }
                100% {
                    opacity: 0;
                    transform: scale(0);
                    left: -25vw;
                }
            }
        </style>
        <h1 class="fragment scale-in" data-autoslide="300">Archaeology</h1>
        <h2 class="fragment scale-in" data-autoslide="300">and the Bible</h2>
        <div class="r-stack image-slides fragment carousel" data-autoslide="1300">
            <img src="https://www.cedarparkchurchofchrist.org/media/uploads/src/board/classes/2024-03-31_archeology/item-1.png" class="animations-to-pause" />
            <img src="https://www.cedarparkchurchofchrist.org/media/uploads/src/board/classes/2024-03-31_archeology/item-2.png" class="animations-to-pause" />
            <img src="https://www.cedarparkchurchofchrist.org/media/uploads/src/board/classes/2024-03-31_archeology/item-3.png" class="animations-to-pause" />
        </div>
        <h3 class="fragment scale-in" data-autoslide="25700">${val}</h3>
    `;
    createSlide({
        center: true,
        autoslide: 150,
        wrap: true,
        html: html,
        background: {
            image: "https://www.cedarparkchurchofchrist.org/media/uploads/src/board/classes/2024-03-31_archeology/bg-slide.png",
            color: "#000",
        },
    }, "ArchaeologyAndTheBibleMarch31");
}
